import React from 'react';
import { IPermanentMedicament } from '../PernamentMedicationItem';
import EPrescriptionMedicamentsHVLPForm from '../../EPrescriptionMedicamentsHVLPForm';
import { useCreateUserMedicationLastedMutation } from '../../../../../graphql/graphql';
import useNotification from '../../../../../Hooks/useNotification.hook';
import useTranslation from '../../../../../Hooks/useTranslation';
import EPrescriptionMedicamentsIPLPForm from '../../EPrescriptionMedicamentsIPLPForm';
import { useAppContext } from '../../../../../Services/AppContext';
import NavigationStepper, {
	NavigationStepperComponentParams,
	NavigationStepperItemType,
} from '../../../../../Components/Stepper/NavigationStepper';

interface Props {
	patientId: string;
	onCreate: () => void;
}

enum NavigationStepKey {
	HVLP = 'hvlp',
	IPLP = 'iplp',
}

const PermanentMedicationCreate: React.FC<Props> = ({
	onCreate,
	patientId,
}) => {
	const { workplaceId } = useAppContext();
	const { showNotificationSuccess } = useNotification();
	const { t } = useTranslation();
	const [createPermanentMedication] = useCreateUserMedicationLastedMutation();

	const handleSubmit = async (values: any) => {
		const result = await createPermanentMedication({
			input: {
				userId: patientId,
				workplaceId,
				data: values,
			},
		});
		if ('data' in result) {
			showNotificationSuccess({
				content: t('component.permanentMedicationCreate.successfullyAdded'),
			});
			onCreate();
		}
	};

	const steps: NavigationStepperItemType[] = [
		{
			name: 'HVLP',
			key: NavigationStepKey.HVLP,
			component: (params: NavigationStepperComponentParams) => (
				<EPrescriptionMedicamentsHVLPForm
					onSubmit={handleSubmit}
					isSelfPayer={false}
					submitButtonText='base.shared.add'
				/>
			),
		},
		{
			name: 'IPLP',
			key: NavigationStepKey.IPLP,
			component: (params: NavigationStepperComponentParams) => (
				<EPrescriptionMedicamentsIPLPForm
					onSubmit={handleSubmit}
					isSelfPayer={false}
					submitButtonText='base.shared.add'
				/>
			),
		},
	];

	return (
		<NavigationStepper
			steps={steps}
			initialStepPath={NavigationStepKey.HVLP}
			showStepNumbers={false}
			canSkip
		/>
	);
};

export default PermanentMedicationCreate;
